import { createContext } from 'react';
//
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

export const TemaContext = createContext({});

export default function TemaProvider({ children }) {

    const theme = createTheme({
        palette: {
            primary: { main: '#07418a' },
            secondary: { main: '#F2B950' },
            error: { main: '#A42C2C' },
            warning: { main: '#F28705' },
            info: { main: '#2469A6' },
            success: { main: '#597528' },
        },
    });

    return (
        <TemaContext.Provider
            value={{}}
        >
            <ThemeProvider theme={theme}>
                <CssBaseline enableColorScheme />
                {children}
            </ThemeProvider>
        </TemaContext.Provider>
    );
}